import {SetState} from '@wandb/weave/common/util/types';
// @todo: Migrate to 'TextField' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {TextField} from '@wandb/weave/components/Form/TextField';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import _ from 'lodash';
import React, {useMemo, useState} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Menu} from 'semantic-ui-react';

import {DEFAULT_PAGE_SIZE_OPTIONS} from './util';
import type {WBReactTableProps} from './WBReactTable';
import {WBReactTablePagination} from './WBReactTablePagination';

type WBReactTableHeaderProps = Pick<
  WBReactTableProps,
  | `pageSizeOptions`
  | `noSearch`
  | `noPaging`
  | `extraActions`
  | `headerInfo`
  | `searchPlaceholder`
  | `hasNextPage`
  | `fetchingNextPage`
  | `onFetchNextPage`
> & {
  page: number;
  pageSize: number;
  rowCount: number;
  changePageSize: (newPageSize: number) => void;
  setPage: SetState<number>;
  onSearch: (query: string) => void;
  initialSearchQuery?: string;
};

export const WBReactTableHeader: React.FC<WBReactTableHeaderProps> = React.memo(
  ({
    page,
    pageSize,
    pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
    rowCount,
    noSearch = false,
    noPaging = false,
    extraActions,
    headerInfo,
    searchPlaceholder,
    changePageSize,
    hasNextPage = false,
    fetchingNextPage = false,
    onFetchNextPage,
    setPage,
    onSearch,
    initialSearchQuery = '',
  }) => {
    const debouncedSearch = useMemo(() => {
      return _.debounce(value => {
        onSearch(value);
      }, 200);
    }, [onSearch]);

    const [searchQuery, setSearchQuery] = useState(initialSearchQuery);

    const handleInputChange = (text: string) => {
      setSearchQuery(text);
      debouncedSearch(text);
    };

    return (
      <Tailwind>
        <Menu
          secondary
          style={{margin: '0px', overflowX: 'auto', alignItems: 'center'}}>
          {!noSearch && (
            <div className="ml-12 mr-20 block flex-auto">
              <TextField
                icon="search"
                placeholder={searchPlaceholder ?? 'Search'}
                value={searchQuery}
                onChange={handleInputChange}
              />
            </div>
          )}
          {headerInfo}
          {!noPaging && (
            <WBReactTablePagination
              page={page}
              pageSize={pageSize}
              pageSizeOptions={pageSizeOptions}
              rowCount={rowCount}
              changePageSize={changePageSize}
              hasNextPage={hasNextPage}
              fetchingNextPage={fetchingNextPage}
              onFetchNextPage={onFetchNextPage}
              setPage={setPage}
              extraActions={extraActions}
            />
          )}
        </Menu>
      </Tailwind>
    );
  }
);
